import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1)
const _hoisted_3 = { class: "flex flex-col justify-evenly z-20 w-96 h-48 bg-white p-4 rounded-md shadow-md" }
const _hoisted_4 = { class: "flex flex-col items-center" }

import { useUserStore } from '@/stores/UserStore'
  import { storeToRefs } from 'pinia'
  import { useRouter } from 'vue-router'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    isVisible:Boolean
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  const router = useRouter()

  const {userEmail,userId } = storeToRefs(useUserStore())  
  
  
  
  
  const closeModalGoProfil = () => {
    emit('close');
    router.push(`/user/${userId.value}`);
  };
  const closeModalGoHomePage = () => {
    emit('close');
    router.push(`/`);
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "flex flex-col items-center justify-end" }, [
                _createElementVNode("button", {
                  onClick: closeModalGoProfil,
                  class: "mt-4 px-4 py-2 w-72 bg-blue-500 text-white rounded-md"
                }, "Mes réservations")
              ]),
              _createElementVNode("div", { class: "flex flex-col items-center justify-end" }, [
                _createElementVNode("button", {
                  onClick: closeModalGoHomePage,
                  class: "mt-1 px-4 py-2 w-72 bg-white text-gray-700 rounded-md border border-gray-600 border-solid"
                }, "Fermer")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})